export default "/images/edit-icon-blue.png?c2ed6168c87f2f7b26dbeef81b9afc27";